import VueTheMask from 'vue-the-mask'

export default function (app) {
  app.use(VueTheMask)
}